import { render, staticRenderFns } from "./SubscriptionsCard.vue?vue&type=template&id=2298b183"
import script from "./SubscriptionsCard.vue?vue&type=script&lang=js"
export * from "./SubscriptionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports